import React from 'react';

import AdminCompactChatAgent from './AdminCompactChatAgent';

function AdminChatWidget() {
    return <AdminCompactChatAgent />;
}

export default AdminChatWidget;
